'use strict';

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(cborCids);

var multihashes = require('multihashes');

var CID = require('cids');

var protobuf = require('protons');

var fnv1a = require('fnv1a');

var varint = require('varint');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode,
    DAGLink = _require.DAGLink;

var multicodec = require('multicodec');

var _require2 = require('p-queue'),
    Queue = _require2.default;

var dagCborLinks = require('dag-cbor-links');

var log = require('debug')('ipfs:pin:pin-set');

var pbSchema = require('./pin.proto');

var emptyKeyHash = 'QmdfTbBqBPQ7VNxZEYEj14VmRuZBkqFbiwReogJgS1zR1n';
var emptyKey = multihashes.fromB58String(emptyKeyHash);
var defaultFanout = 256;
var maxItems = 8192;
var pb = protobuf(pbSchema);
var HAS_DESCENDANT_CONCURRENCY = 100;

function toB58String(hash) {
  return new CID(hash).toBaseEncodedString();
}

function readHeader(rootNode) {
  // rootNode.data should be a buffer of the format:
  // < varint(headerLength) | header | itemData... >
  var rootData = rootNode.Data;
  var hdrLength = varint.decode(rootData);
  var vBytes = varint.decode.bytes;

  if (vBytes <= 0) {
    throw new Error('Invalid Set header length');
  }

  if (vBytes + hdrLength > rootData.length) {
    throw new Error('Impossibly large set header length');
  }

  var hdrSlice = rootData.slice(vBytes, hdrLength + vBytes);
  var header = pb.Set.decode(hdrSlice);

  if (header.version !== 1) {
    throw new Error("Unsupported Set version: ".concat(header.version));
  }

  if (header.fanout > rootNode.Links.length) {
    throw new Error('Impossibly large fanout');
  }

  return {
    header: header,
    data: rootData.slice(hdrLength + vBytes)
  };
}

function hash(seed, key) {
  var buf = Buffer.alloc(4);
  buf.writeUInt32LE(seed, 0);
  var data = Buffer.concat([buf, Buffer.from(toB58String(key))]);
  return fnv1a(data.toString('binary'));
}

function cborCids(node) {
  var _iterator, _step, _step$value, _, cid;

  return _regeneratorRuntime.wrap(function cborCids$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _iterator = _createForOfIteratorHelper(dagCborLinks(node));
          _context.prev = 1;

          _iterator.s();

        case 3:
          if ((_step = _iterator.n()).done) {
            _context.next = 9;
            break;
          }

          _step$value = _slicedToArray(_step.value, 2), _ = _step$value[0], cid = _step$value[1];
          _context.next = 7;
          return cid;

        case 7:
          _context.next = 3;
          break;

        case 9:
          _context.next = 14;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);

          _iterator.e(_context.t0);

        case 14:
          _context.prev = 14;

          _iterator.f();

          return _context.finish(14);

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 11, 14, 17]]);
}

exports = module.exports = function (dag) {
  var pinSet = {
    // should this be part of `object` API?
    hasDescendant: function () {
      var _hasDescendant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(parentCid, childhash) {
        var _yield$dag$get, root, queue, found, seen, searchChild, searchChildren;

        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                searchChildren = function _searchChildren(cid, node) {
                  var links = [];

                  if (cid.codec === 'dag-pb') {
                    links = node.Links;
                  } else if (cid.codec === 'dag-cbor') {
                    links = cborCids(node);
                  }

                  var _iterator2 = _createForOfIteratorHelper(links),
                      _step2;

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var link = _step2.value;
                      var linkCid = cid.codec === 'dag-pb' ? link.Hash : link[1];
                      var bs58Link = toB58String(linkCid);

                      if (bs58Link === childhash) {
                        queue.clear();
                        found = true;
                        return;
                      }

                      if (seen[bs58Link]) {
                        continue;
                      }

                      seen[bs58Link] = true;

                      if (linkCid.codec !== 'dag-pb' && linkCid.codec !== 'dag-cbor') {
                        continue;
                      }

                      queue.add(searchChild(linkCid));
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                };

                searchChild = function _searchChild(linkCid) {
                  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$dag$get2, childNode;

                    return _regeneratorRuntime.wrap(function _callee$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!found) {
                              _context2.next = 2;
                              break;
                            }

                            return _context2.abrupt("return");

                          case 2:
                            _context2.prev = 2;
                            _context2.next = 5;
                            return dag.get(linkCid, {
                              preload: false
                            });

                          case 5:
                            _yield$dag$get2 = _context2.sent;
                            childNode = _yield$dag$get2.value;
                            searchChildren(linkCid, childNode);
                            _context2.next = 13;
                            break;

                          case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2["catch"](2);
                            log(_context2.t0);

                          case 13:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee, null, [[2, 10]]);
                  }));
                };

                if (!(parentCid.codec !== 'dag-pb' && parentCid.codec !== 'dag-cbor')) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", false);

              case 4:
                _context3.next = 6;
                return dag.get(parentCid, {
                  preload: false
                });

              case 6:
                _yield$dag$get = _context3.sent;
                root = _yield$dag$get.value;
                queue = new Queue({
                  concurrency: HAS_DESCENDANT_CONCURRENCY
                });

                if (CID.isCID(childhash) || Buffer.isBuffer(childhash)) {
                  childhash = toB58String(childhash);
                }

                found = false;
                seen = {};
                searchChildren(parentCid, root);
                _context3.next = 15;
                return queue.onIdle();

              case 15:
                return _context3.abrupt("return", found);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2);
      }));

      function hasDescendant(_x, _x2) {
        return _hasDescendant.apply(this, arguments);
      }

      return hasDescendant;
    }(),
    storeSet: function () {
      var _storeSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(keys) {
        var pins, rootNode, cid;
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                pins = keys.map(function (key) {
                  if (typeof key === 'string' || Buffer.isBuffer(key)) {
                    key = new CID(key);
                  }

                  return {
                    key: key,
                    data: null
                  };
                });
                _context4.next = 3;
                return pinSet.storeItems(pins);

              case 3:
                rootNode = _context4.sent;
                _context4.next = 6;
                return dag.put(rootNode, {
                  version: 0,
                  format: multicodec.DAG_PB,
                  hashAlg: multicodec.SHA2_256,
                  preload: false
                });

              case 6:
                cid = _context4.sent;
                return _context4.abrupt("return", {
                  node: rootNode,
                  cid: cid
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3);
      }));

      function storeSet(_x3) {
        return _storeSet.apply(this, arguments);
      }

      return storeSet;
    }(),
    storeItems: function () {
      var _storeItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(items) {
        var storePins, _storePins;

        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _storePins = function _storePins3() {
                  _storePins = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(pins, depth) {
                    var pbHeader, headerBuf, fanoutLinks, i, nodes, rootLinks, rootData, bins, idx, _iterator3, _step3, bin, child, storeChild, _storeChild;

                    return _regeneratorRuntime.wrap(function _callee5$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _storeChild = function _storeChild3() {
                              _storeChild = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(child, binIdx) {
                                var opts, cid;
                                return _regeneratorRuntime.wrap(function _callee4$(_context5) {
                                  while (1) {
                                    switch (_context5.prev = _context5.next) {
                                      case 0:
                                        opts = {
                                          version: 0,
                                          format: multicodec.DAG_PB,
                                          hashAlg: multicodec.SHA2_256,
                                          preload: false
                                        };
                                        _context5.next = 3;
                                        return dag.put(child, opts);

                                      case 3:
                                        cid = _context5.sent;
                                        fanoutLinks[binIdx] = new DAGLink('', child.size, cid);

                                      case 5:
                                      case "end":
                                        return _context5.stop();
                                    }
                                  }
                                }, _callee4);
                              }));
                              return _storeChild.apply(this, arguments);
                            };

                            storeChild = function _storeChild2(_x7, _x8) {
                              return _storeChild.apply(this, arguments);
                            };

                            pbHeader = pb.Set.encode({
                              version: 1,
                              fanout: defaultFanout,
                              seed: depth
                            });
                            headerBuf = Buffer.concat([Buffer.from(varint.encode(pbHeader.length)), pbHeader]);
                            fanoutLinks = [];

                            for (i = 0; i < defaultFanout; i++) {
                              fanoutLinks.push(new DAGLink('', 1, emptyKey));
                            }

                            if (!(pins.length <= maxItems)) {
                              _context6.next = 13;
                              break;
                            }

                            nodes = pins.map(function (item) {
                              return {
                                link: new DAGLink('', 1, item.key),
                                data: item.data || Buffer.alloc(0)
                              };
                            }) // sorting makes any ordering of `pins` produce the same DAGNode
                            .sort(function (a, b) {
                              return Buffer.compare(a.link.Hash.buffer, b.link.Hash.buffer);
                            });
                            rootLinks = fanoutLinks.concat(nodes.map(function (item) {
                              return item.link;
                            }));
                            rootData = Buffer.concat([headerBuf].concat(nodes.map(function (item) {
                              return item.data;
                            })));
                            return _context6.abrupt("return", new DAGNode(rootData, rootLinks));

                          case 13:
                            // If the array of pins is > maxItems, we:
                            //  - distribute the pins among `defaultFanout` bins
                            //    - create a DAGNode for each bin
                            //      - add each pin as a DAGLink to that bin
                            //  - create a root DAGNode
                            //    - add each bin as a DAGLink
                            //  - send that root DAGNode via callback
                            // (using go-ipfs' "wasteful but simple" approach for consistency)
                            // https://github.com/ipfs/go-ipfs/blob/master/pin/set.go#L57
                            bins = pins.reduce(function (bins, pin) {
                              var n = hash(depth, pin.key) % defaultFanout;
                              bins[n] = n in bins ? bins[n].concat([pin]) : [pin];
                              return bins;
                            }, []);
                            idx = 0;
                            _iterator3 = _createForOfIteratorHelper(bins);
                            _context6.prev = 16;

                            _iterator3.s();

                          case 18:
                            if ((_step3 = _iterator3.n()).done) {
                              _context6.next = 28;
                              break;
                            }

                            bin = _step3.value;
                            _context6.next = 22;
                            return storePins(bin, depth + 1);

                          case 22:
                            child = _context6.sent;
                            _context6.next = 25;
                            return storeChild(child, idx);

                          case 25:
                            idx++;

                          case 26:
                            _context6.next = 18;
                            break;

                          case 28:
                            _context6.next = 33;
                            break;

                          case 30:
                            _context6.prev = 30;
                            _context6.t0 = _context6["catch"](16);

                            _iterator3.e(_context6.t0);

                          case 33:
                            _context6.prev = 33;

                            _iterator3.f();

                            return _context6.finish(33);

                          case 36:
                            return _context6.abrupt("return", new DAGNode(headerBuf, fanoutLinks));

                          case 37:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee5, null, [[16, 30, 33, 36]]);
                  }));
                  return _storePins.apply(this, arguments);
                };

                storePins = function _storePins2(_x5, _x6) {
                  return _storePins.apply(this, arguments);
                };

                return _context7.abrupt("return", storePins(items, 0));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6);
      }));

      function storeItems(_x4) {
        return _storeItems.apply(this, arguments);
      }

      return storeItems;
    }(),
    loadSet: function () {
      var _loadSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(rootNode, name) {
        var link, res, keys, stepPin;
        return _regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                link = rootNode.Links.find(function (l) {
                  return l.Name === name;
                });

                if (link) {
                  _context8.next = 3;
                  break;
                }

                throw new Error('No link found with name ' + name);

              case 3:
                _context8.next = 5;
                return dag.get(link.Hash, '', {
                  preload: false
                });

              case 5:
                res = _context8.sent;
                keys = [];

                stepPin = function stepPin(link) {
                  return keys.push(link.Hash);
                };

                _context8.next = 10;
                return pinSet.walkItems(res.value, {
                  stepPin: stepPin
                });

              case 10:
                return _context8.abrupt("return", keys);

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee7);
      }));

      function loadSet(_x9, _x10) {
        return _loadSet.apply(this, arguments);
      }

      return loadSet;
    }(),
    walkItems: function () {
      var _walkItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(node, _ref2) {
        var _ref2$stepPin, stepPin, _ref2$stepBin, stepBin, pbh, idx, _iterator4, _step4, link, linkHash, res;

        return _regeneratorRuntime.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _ref2$stepPin = _ref2.stepPin, stepPin = _ref2$stepPin === void 0 ? function () {} : _ref2$stepPin, _ref2$stepBin = _ref2.stepBin, stepBin = _ref2$stepBin === void 0 ? function () {} : _ref2$stepBin;
                pbh = readHeader(node);
                idx = 0;
                _iterator4 = _createForOfIteratorHelper(node.Links);
                _context9.prev = 4;

                _iterator4.s();

              case 6:
                if ((_step4 = _iterator4.n()).done) {
                  _context9.next = 23;
                  break;
                }

                link = _step4.value;

                if (!(idx < pbh.header.fanout)) {
                  _context9.next = 19;
                  break;
                }

                // the first pbh.header.fanout links are fanout bins
                // if a fanout bin is not 'empty', dig into and walk its DAGLinks
                linkHash = link.Hash.buffer;

                if (emptyKey.equals(linkHash)) {
                  _context9.next = 17;
                  break;
                }

                stepBin(link, idx, pbh.data); // walk the links of this fanout bin

                _context9.next = 14;
                return dag.get(linkHash, '', {
                  preload: false
                });

              case 14:
                res = _context9.sent;
                _context9.next = 17;
                return pinSet.walkItems(res.value, {
                  stepPin: stepPin,
                  stepBin: stepBin
                });

              case 17:
                _context9.next = 20;
                break;

              case 19:
                // otherwise, the link is a pin
                stepPin(link, idx, pbh.data);

              case 20:
                idx++;

              case 21:
                _context9.next = 6;
                break;

              case 23:
                _context9.next = 28;
                break;

              case 25:
                _context9.prev = 25;
                _context9.t0 = _context9["catch"](4);

                _iterator4.e(_context9.t0);

              case 28:
                _context9.prev = 28;

                _iterator4.f();

                return _context9.finish(28);

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee8, null, [[4, 25, 28, 31]]);
      }));

      function walkItems(_x11, _x12) {
        return _walkItems.apply(this, arguments);
      }

      return walkItems;
    }(),
    getInternalCids: function () {
      var _getInternalCids = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(rootNode) {
        var cids, stepBin, _iterator5, _step5, topLevelLink, res;

        return _regeneratorRuntime.wrap(function _callee9$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                // "Empty block" used by the pinner
                cids = [new CID(emptyKey)];

                stepBin = function stepBin(link) {
                  return cids.push(link.Hash);
                };

                _iterator5 = _createForOfIteratorHelper(rootNode.Links);
                _context10.prev = 3;

                _iterator5.s();

              case 5:
                if ((_step5 = _iterator5.n()).done) {
                  _context10.next = 15;
                  break;
                }

                topLevelLink = _step5.value;
                cids.push(topLevelLink.Hash);
                _context10.next = 10;
                return dag.get(topLevelLink.Hash, '', {
                  preload: false
                });

              case 10:
                res = _context10.sent;
                _context10.next = 13;
                return pinSet.walkItems(res.value, {
                  stepBin: stepBin
                });

              case 13:
                _context10.next = 5;
                break;

              case 15:
                _context10.next = 20;
                break;

              case 17:
                _context10.prev = 17;
                _context10.t0 = _context10["catch"](3);

                _iterator5.e(_context10.t0);

              case 20:
                _context10.prev = 20;

                _iterator5.f();

                return _context10.finish(20);

              case 23:
                return _context10.abrupt("return", cids);

              case 24:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee9, null, [[3, 17, 20, 23]]);
      }));

      function getInternalCids(_x13) {
        return _getInternalCids.apply(this, arguments);
      }

      return getInternalCids;
    }()
  };
  return pinSet;
};